import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const messages = {
  pl: {
    meta: {
      title: 'AntZone | Aplikacje webowe i mobilne',
      description: 'AntZone - tworzymy dedykowane aplikacje webowe i mobilne.',
    },
    nav: ['O nas', 'Usługi', 'Proces', 'Aplikacje', 'Kontakt'],
    talk: 'Porozmawiajmy',
    hero: {
      badge: 'Oprogramowanie dopasowane do Twojej firmy',
      title: 'Projektujemy i rozwijamy',
      accent: ' aplikacje dla biznesu',
      description: 'Tworzymy aplikacje webowe i mobilne dopasowane do procesów, celów oraz możliwości Twojej firmy. Pomagamy przejść od analizy pomysłu do wdrożenia i dalszego rozwoju produktu.',
      primary: 'Porozmawiajmy o projekcie',
      secondary: 'Jak pracujemy',
    },
    about: {
      badge: 'O nas',
      title: 'Poznaj',
      intro: 'Łączymy projektowanie, programowanie i analizę biznesową. Pomagamy tworzyć oraz rozwijać aplikacje dopasowane do sposobu działania organizacji.',
      cards: [
        ['Dlaczego my?', 'Zaczynamy od poznania celów biznesowych i realnych potrzeb użytkowników. Dobieramy zakres prac, technologię i sposób realizacji do konkretnego projektu, zamiast korzystać z jednego schematu.'],
        ['Nasza misja', 'Chcemy tworzyć oprogramowanie, które rozwiązuje konkretne problemy i może rozwijać się razem z firmą. Stawiamy na jasną komunikację, partnerską współpracę i odpowiedzialne podejście do decyzji.'],
        ['Co możemy zbudować?', 'Projektujemy aplikacje webowe i mobilne, integracje oraz narzędzia do automatyzacji pracy z danymi. Korzystamy między innymi z React, Node.js, Python i .NET, dobierając technologie do wymagań produktu.'],
        ['Nasze podejście', 'Łączymy wiedzę techniczną z analizą biznesową. Dzielimy pracę na etapy, regularnie prezentujemy postępy i wspólnie ustalamy priorytety, dzięki czemu projekt może reagować na nowe informacje.'],
      ],
      values: [
        ['Kreatywni', 'Szukamy prostych rozwiązań dla konkretnych problemów'],
        ['Praktyczni', 'Dobieramy zakres i technologię do potrzeb projektu'],
        ['Przejrzyści', 'Informujemy o postępach, ryzykach i ważnych decyzjach'],
        ['Zaangażowani', 'Łączymy cele produktu z odpowiedzialną pracą techniczną'],
      ],
    },
    services: {
      badge: 'Nasze usługi',
      title: 'Rozwiązania dopasowane do',
      accent: ' realnych potrzeb',
      intro: 'Pomagamy projektować, budować i rozwijać oprogramowanie dla firm i zespołów.',
      mobileTypes: 'Rodzaje aplikacji mobilnych:',
      items: [
        {
          title: 'Aplikacje Mobilne',
          description: 'Tworzymy aplikacje mobilne wspierające pracę zespołów terenowych, sprzedaż, raportowanie i dostęp do danych poza biurem.',
          features: ['Praca w terenie - sprzedaż, raportowanie, ankiety i obsługa zadań', 'Procesy wewnętrzne - wsparcie logistyki, magazynu i produkcji', 'Dostęp do danych - bieżące informacje dostępne na urządzeniu mobilnym', 'Zarządzanie - podgląd kluczowych danych i statusów z dowolnego miejsca'],
          types: [['Natywne', 'Rozwiązania dla Androida lub iOS z szerokim dostępem do funkcji urządzenia'], ['Wieloplatformowe', 'Jedna baza kodu dla kilku platform, gdy pozwalają na to wymagania produktu'], ['Webowe', 'Aplikacje działające w przeglądarce, bez instalacji ze sklepu']],
        },
        {
          title: 'Aplikacje Dedykowane',
          description: 'Tworzymy aplikacje webowe dopasowane do procesów, użytkowników i planów rozwoju organizacji.',
          features: ['Elastyczność - zakres i architektura dopasowane do potrzeb projektu', 'Wydajność - rozwiązania dobierane na podstawie sposobu użycia systemu', 'UX/UI - czytelne interfejsy projektowane z myślą o użytkownikach', 'Modułowość - możliwość etapowego rozwijania aplikacji', 'Integracje - połączenie z zewnętrznymi usługami i systemami przez API'],
        },
        {
          title: 'Web Scraping & Data Mining',
          description: 'Budujemy narzędzia do pozyskiwania, porządkowania i analizy danych z dostępnych źródeł internetowych.',
          features: ['Pozyskiwanie - automatyczne zbieranie określonych danych', 'Przetwarzanie - czyszczenie, porządkowanie i łączenie informacji', 'Automatyzacja - cykliczne uruchamianie zadań i aktualizacja wyników', 'Analiza - raporty i zestawienia wspierające podejmowanie decyzji'],
        },
      ],
    },
    process: {
      badge: 'Nasz proces',
      title: 'Jak',
      accent: ' tworzymy oprogramowanie',
      intro: 'Zakres i tempo prac dopasowujemy do celów, budżetu oraz stopnia złożoności projektu.',
      methodology: 'Nasza metodologia',
      methodologyText: 'Sposób pracy dobieramy do skali i charakteru projektu. Najczęściej dzielimy realizację na krótkie etapy, regularnie prezentujemy postępy i zbieramy informację zwrotną. Dzięki temu priorytety mogą być aktualizowane na podstawie wiedzy zdobywanej w trakcie prac.',
      steps: [
        ['Analiza projektu', 'Poznajemy cele biznesowe, użytkowników i najważniejsze wymagania. Podczas rozmów i warsztatów porządkujemy zakres, wskazujemy ryzyka oraz ustalamy plan pierwszego etapu prac.', 'Zależnie od zakresu'],
        ['Projekt UX/UI', 'Projektujemy ścieżki użytkownika, makiety i kluczowe widoki aplikacji. Zakres prototypowania oraz badań użyteczności ustalamy odpowiednio do potrzeb i etapu rozwoju produktu.', 'Zależnie od zakresu'],
        ['Tworzenie aplikacji', 'Rozwijamy produkt etapami i regularnie prezentujemy działające elementy. Stosujemy przeglądy kodu oraz testy dobrane do ryzyka, architektury i wymagań danego projektu.', 'Praca etapowa'],
        ['Wdrożenie', 'Przygotowujemy aplikację i środowisko do uruchomienia. Zakres testów akceptacyjnych, dokumentacji, szkoleń i wsparcia po starcie ustalamy wspólnie przed wdrożeniem.', 'Według planu wdrożenia'],
        ['Ciągły rozwój', 'Po uruchomieniu możemy wspierać utrzymanie i dalszy rozwój aplikacji. Zakres współpracy może obejmować poprawki, aktualizacje, monitoring oraz kolejne funkcje.', 'Opcjonalnie'],
      ],
    },
    applications: {
      badge: 'Nasze technologie',
      title: 'Technologie dobieramy do',
      accent: ' potrzeb produktu',
      intro: 'Dobieramy technologie do wymagań produktu, kompetencji zespołu i planów dalszego rozwoju.',
      faqTitle: 'Często zadawane pytania',
      faqIntro: 'Odpowiedzi na pytania, które często pojawiają się przed rozpoczęciem współpracy',
      benefits: [
        ['Wydajność', 'Wydajność analizowana i optymalizowana odpowiednio do sposobu użycia aplikacji'],
        ['Bezpieczeństwo', 'Zabezpieczenia i ochrona danych dobierane do charakteru systemu oraz wymagań projektu'],
        ['Skalowalność', 'Architektura planowana z uwzględnieniem przewidywanego rozwoju produktu'],
        ['Intuicyjność', 'Interfejsy projektowane z myślą o zadaniach i potrzebach użytkowników'],
      ],
      database: 'Bazy danych',
      faq: [
        ['Jak długo trwa realizacja projektu?', 'Czas realizacji zależy od zakresu, integracji, dostępności materiałów i sposobu podejmowania decyzji. Po wstępnej analizie proponujemy etapy prac oraz orientacyjny harmonogram.'],
        ['Czy oferujecie wsparcie powdrożeniowe?', 'Możemy zapewnić wsparcie po uruchomieniu, obejmujące utrzymanie, poprawki, aktualizacje lub dalszy rozwój. Dokładny zakres, czas reakcji i warunki ustalamy indywidualnie w umowie.'],
        ['Jakie są koszty tworzenia aplikacji?', 'Koszt zależy między innymi od zakresu funkcji, integracji, wymagań dotyczących bezpieczeństwa i oczekiwanego terminu. Po poznaniu potrzeb przedstawiamy proponowany zakres, model współpracy i wycenę.'],
        ['Czy otrzymam prawa do kodu źródłowego?', 'Zasady przekazania kodu, dokumentacji i praw do rezultatów prac określamy w umowie. Uwzględniamy przy tym licencje wykorzystywanych bibliotek, usług oraz innych komponentów zewnętrznych.'],
        ['Czy tworzycie aplikacje na konkretne branże?', 'Każdy projekt rozpoczynamy od poznania procesów, użytkowników i wymagań właściwych dla danej branży. Przed rozpoczęciem współpracy oceniamy również, czy potrzebna jest dodatkowa wiedza domenowa lub wsparcie specjalistów.'],
      ],
    },
    contact: {
      badge: 'Kontakt',
      title: 'Porozmawiajmy o',
      accent: ' Twoim projekcie',
      intro: 'Opowiedz nam o swoim pomyśle, potrzebach i najważniejszych ograniczeniach projektu.',
      questions: 'Masz pytania?',
      questionsText: 'W formularzu możesz opisać swój projekt, jego obecny etap oraz oczekiwany zakres wsparcia. Na tej podstawie łatwiej będzie przygotować się do pierwszej rozmowy.',
      vision: 'Twoja wizja',
      experience: 'Nasze doświadczenie',
      result: 'Sukces biznesowy',
      ready: 'Zacznijmy od poznania potrzeb',
      describe: 'Opisz swój projekt',
      consultation: 'Rozmowa o projekcie',
      consultationText: 'Prześlij podstawowe informacje o projekcie. Po zapoznaniu się z nimi możemy omówić potrzeby, możliwy zakres prac i kolejne kroki.',
      goToForm: 'Przejdź do formularza',
      labels: ['Imię i nazwisko *', 'E-mail *', 'Telefon', 'Temat *', 'Wiadomość *'],
      placeholders: ['Jan Kowalski', 'jan@example.com', '+48 123 456 789', 'W czym możemy pomóc?', 'Opisz szczegóły swojego projektu...'],
      submit: 'Sprawdź formularz',
      inactiveTitle: 'Formularz nie jest jeszcze aktywny',
      inactiveText: 'Wiadomość nie została wysłana. Formularz wymaga podłączenia do usługi pocztowej lub backendu.',
    },
    footer: {
      first: 'Projektujemy i rozwijamy aplikacje webowe oraz mobilne.',
      second: 'Technologia jest narzędziem',
      third: ', a punktem wyjścia są potrzeby użytkowników',
      fourth: ' i cele biznesowe projektu.',
      rights: 'Wszelkie prawa zastrzeżone.',
    },
  },
  en: {
    meta: {
      title: 'AntZone | Web and mobile applications',
      description: 'AntZone - custom web and mobile application development.',
    },
    nav: ['About', 'Services', 'Process', 'Technology', 'Contact'],
    talk: 'Let’s talk',
    hero: {
      badge: 'Software tailored to your company',
      title: 'We design and develop',
      accent: ' business applications',
      description: 'We build web and mobile applications around your company’s processes, goals, and capabilities. We help you move from idea analysis through launch and continued product development.',
      primary: 'Tell us about your project',
      secondary: 'How we work',
    },
    about: {
      badge: 'About us',
      title: 'Meet',
      intro: 'We combine design, software development, and business analysis to create applications that fit the way organizations work.',
      cards: [
        ['Why us?', 'We start by understanding business goals and real user needs. The scope, technology, and delivery model are selected for each project rather than forced into one template.'],
        ['Our mission', 'We want to create software that solves specific problems and can grow with the business. We value clear communication, partnership, and responsible decision-making.'],
        ['What can we build?', 'We design web and mobile applications, integrations, and data automation tools. We work with technologies including React, Node.js, Python, and .NET, selecting them to match product requirements.'],
        ['Our approach', 'We combine technical expertise with business analysis. Work is divided into stages, progress is demonstrated regularly, and priorities are agreed together as new information emerges.'],
      ],
      values: [
        ['Creative', 'We look for simple solutions to specific problems'],
        ['Practical', 'We match scope and technology to project needs'],
        ['Transparent', 'We communicate progress, risks, and key decisions'],
        ['Committed', 'We connect product goals with responsible engineering'],
      ],
    },
    services: {
      badge: 'Our services',
      title: 'Solutions tailored to',
      accent: ' real needs',
      intro: 'We help companies and teams design, build, and develop software.',
      mobileTypes: 'Mobile application types:',
      items: [
        {
          title: 'Mobile Applications',
          description: 'We build mobile applications for field teams, sales, reporting, and access to data outside the office.',
          features: ['Field work - sales, reporting, surveys, and task handling', 'Internal processes - support for logistics, warehousing, and production', 'Data access - current information available on mobile devices', 'Management - access to key data and statuses from anywhere'],
          types: [['Native', 'Android or iOS solutions with broad access to device capabilities'], ['Cross-platform', 'A shared codebase for multiple platforms when product requirements allow it'], ['Web', 'Browser-based applications that do not require app-store installation']],
        },
        {
          title: 'Custom Web Applications',
          description: 'We create web applications tailored to organizational processes, users, and growth plans.',
          features: ['Flexibility - scope and architecture matched to project needs', 'Performance - solutions selected around expected system usage', 'UX/UI - clear interfaces designed around user needs', 'Modularity - applications that can be developed in stages', 'Integrations - connections to external services and systems through APIs'],
        },
        {
          title: 'Web Scraping & Data Mining',
          description: 'We build tools for collecting, organizing, and analyzing data from available online sources.',
          features: ['Collection - automated gathering of selected data', 'Processing - cleaning, organizing, and combining information', 'Automation - scheduled tasks and result updates', 'Analysis - reports and summaries supporting decision-making'],
        },
      ],
    },
    process: {
      badge: 'Our process',
      title: 'How we',
      accent: ' build software',
      intro: 'We adapt the scope and pace of work to the project’s goals, budget, and complexity.',
      methodology: 'Our methodology',
      methodologyText: 'We adapt the way we work to the scale and nature of the project. Delivery is usually divided into short stages, with regular progress demonstrations and feedback. This allows priorities to evolve as the team learns more.',
      steps: [
        ['Project analysis', 'We learn about business goals, users, and key requirements. Through discussions and workshops, we organize the scope, identify risks, and define the first stage of work.', 'Depends on scope'],
        ['UX/UI design', 'We design user journeys, wireframes, and key application screens. The scope of prototyping and usability research is matched to the product’s needs and maturity.', 'Depends on scope'],
        ['Application development', 'We develop the product in stages and regularly demonstrate working functionality. Code reviews and tests are selected according to project risk, architecture, and requirements.', 'Iterative delivery'],
        ['Deployment', 'We prepare the application and its environment for launch. Acceptance testing, documentation, training, and post-launch support are agreed before deployment.', 'Based on launch plan'],
        ['Continuous development', 'After launch, we can support maintenance and further development. This may include fixes, updates, monitoring, and new functionality.', 'Optional'],
      ],
    },
    applications: {
      badge: 'Our technology',
      title: 'Technology selected for',
      accent: ' product needs',
      intro: 'We select technology based on product requirements, team capabilities, and long-term development plans.',
      faqTitle: 'Frequently asked questions',
      faqIntro: 'Answers to questions that often come up before starting a collaboration',
      benefits: [
        ['Performance', 'Performance is analyzed and optimized for the way the application will be used'],
        ['Security', 'Security and data protection measures are matched to system and project requirements'],
        ['Scalability', 'Architecture is planned with expected product growth in mind'],
        ['Usability', 'Interfaces are designed around user tasks and needs'],
      ],
      database: 'Databases',
      faq: [
        ['How long does a project take?', 'The timeline depends on scope, integrations, available materials, and the decision-making process. After the initial analysis, we propose delivery stages and an indicative schedule.'],
        ['Do you provide post-launch support?', 'We can provide maintenance, fixes, updates, or continued development after launch. The exact scope, response times, and terms are agreed individually in the contract.'],
        ['How much does application development cost?', 'Cost depends on the feature scope, integrations, security requirements, and expected timeline. Once we understand the needs, we present a proposed scope, collaboration model, and estimate.'],
        ['Will I own the source code?', 'The transfer of code, documentation, and rights to project deliverables is defined in the contract, taking into account licenses for libraries, services, and other third-party components.'],
        ['Do you build applications for specific industries?', 'Every project begins with understanding the relevant processes, users, and industry requirements. Before starting, we also assess whether additional domain expertise or specialist support is needed.'],
      ],
    },
    contact: {
      badge: 'Contact',
      title: 'Let’s talk about',
      accent: ' your project',
      intro: 'Tell us about your idea, needs, and the most important project constraints.',
      questions: 'Have questions?',
      questionsText: 'Use the form to describe your project, its current stage, and the support you expect. This will help us prepare for the first conversation.',
      vision: 'Your vision',
      experience: 'Our experience',
      result: 'Business outcome',
      ready: 'Let’s start by understanding your needs',
      describe: 'Describe your project',
      consultation: 'Project conversation',
      consultationText: 'Send us the essential project details. Once reviewed, we can discuss your needs, possible scope, and next steps.',
      goToForm: 'Go to the form',
      labels: ['Full name *', 'E-mail *', 'Phone', 'Subject *', 'Message *'],
      placeholders: ['John Smith', 'john@example.com', '+1 123 456 7890', 'How can we help?', 'Describe your project...'],
      submit: 'Check the form',
      inactiveTitle: 'The form is not active yet',
      inactiveText: 'Your message was not sent. The form still needs to be connected to an e-mail service or backend.',
    },
    footer: {
      first: 'We design and develop web and mobile applications.',
      second: 'Technology is a tool',
      third: ', while user needs',
      fourth: ' and business goals are the starting point.',
      rights: 'All rights reserved.',
    },
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('antzone-language');
    return savedLanguage === 'en' ? 'en' : 'pl';
  });

  useEffect(() => {
    localStorage.setItem('antzone-language', language);
    document.documentElement.lang = language;
    document.title = messages[language].meta.title;
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute('content', messages[language].meta.description);
  }, [language]);

  const value = useMemo(() => ({ language, setLanguage, copy: messages[language] }), [language]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
